module.exports = __webpack_public_path__ + "img/its-dare.38712e9a.svg";